import { z } from "zod";

const sourceTypes = z.enum([
  "Unknown",
  "Accounting",
  "Banking",
  "BankFeed",
  "Commerce",
  "Expense",
  "Other",
]);

export const dataConnectionSchema = z.object({
  id: z.string().uuid(),
  integrationId: z.string().uuid(),
  integrationKey: z.string().optional(),
  sourceId: z.string().uuid(),
  platformName: z.string(),
  linkUrl: z.string(),
  status: z.string(),
  lastSync: z.string().datetime().optional(),
  created: z.string().datetime(),
  sourceType: sourceTypes,
});

export const tagsSchema = z.record(z.string().nullable());

export const companyReferenceSchema = z.object({
  id: z.string().uuid(),
  links: z.object({ portal: z.string() }),
  name: z.string(),
  tags: tagsSchema,
});

export const companySchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
  description: z.string().optional(),
  platform: z.string(),
  redirect: z.string(),
  lastSync: z.string().datetime().optional(),
  dataConnections: z.array(dataConnectionSchema),
  created: z.string().datetime(),
  createdByUserName: z.string().optional(),
  products: z.array(z.string()),
  tags: tagsSchema,
  referenceSubsidiaryCompanies: z.array(companyReferenceSchema).optional(),
});

export const updateCompanyBodySchema = z.object({
  name: z.string().optional(),
  description: z.string().optional(),
  tags: z.record(z.string()).optional(),
});

export const updateCompanyResponseSchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
  redirect: z.string(),
  lastSync: z.string().datetime().optional(),
  created: z.string().datetime(),
  createdByUserName: z.string().optional(),
  tags: tagsSchema,
  dataConnections: z.array(dataConnectionSchema).optional(),
  products: z.array(z.string()),
  referenceSubsidiaryCompanies: z.array(companyReferenceSchema).optional(),
});

export const getCompaniesResponseSchema = z.object({
  results: z.array(companySchema),
  totalResults: z.number(),
  links: z.object({
    next: z.string().url().optional(),
    prev: z.string().url().optional(),
  }),
});

export type Company = z.infer<typeof companySchema>;
export type DataConnection = z.infer<typeof dataConnectionSchema>;
export type UpdateCompanyBody = z.infer<typeof updateCompanyBodySchema>;
export type UpdateCompanyResponse = z.infer<typeof updateCompanyResponseSchema>;
export type GetCompaniesResponse = z.infer<typeof getCompaniesResponseSchema>;
